import React from "react";

const MoonIcon = () => (
  <svg width="20" height="20" fill="none">
    <path
      d="M7.13534 1.63525C6.66385 3.19532 6.62441 4.85406 7.02122 6.43477C7.41803 8.01548 8.23622 9.45893 9.38863 10.6113C10.541 11.7637 11.9845 12.5819 13.5652 12.9787C15.1459 13.3756 16.8047 13.3361 18.3647 12.8646C17.9124 14.3517 17.0828 15.6963 15.9565 16.7674C14.8302 17.8386 13.4457 18.5998 11.9378 18.9769C10.4299 19.354 8.8501 19.3342 7.35216 18.9194C5.85423 18.5045 4.48926 17.7088 3.39019 16.6098C2.29112 15.5107 1.49543 14.1457 1.0806 12.6478C0.665774 11.1499 0.645956 9.57003 1.02308 8.06216C1.4002 6.55429 2.1614 5.16979 3.23255 4.0435C4.3037 2.91721 5.64828 2.08753 7.13534 1.63525Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default MoonIcon;
